module.exports = __webpack_public_path__ + "static/img/CG.3bdc476d.png";